import React, { useState } from 'react';
import HotChartServices from '../../../services/HotChartServices';

const HOTChartTogal = ({ help, page ,onSuccess}) => {
  // Initialize the state based on the user's status
  const [isChecked, setIsChecked] = useState(help?.status === 'Active');

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Active' : 'Inactive';
    setIsChecked(!isChecked);
    

    
      const res = await HotChartServices.updateHotChart(help._id, {
        status: newStatus
      });
      onSuccess();
    

    }

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default HOTChartTogal;
